// extracted by mini-css-extract-plugin
export default {"popupClose":"DeletePopup_popupClose__ou1jK"};